import React from 'react';
import HomeDashboard from '../common/HomeDashboard/HomeDashboard';
import usePermissions from '../../hooks/features/permissions/usePermissions';
import { RESOURCES } from '../../constants/resourceConstants';
import { REQUEST_PRIVILEGES } from '../../constants/privilege.constant';

const Home = () => {
  const {
    hasPrivilege,
    userContext: { isSuper },
  } = usePermissions();
  const canReview = hasPrivilege(RESOURCES.REQUESTS, REQUEST_PRIVILEGES.REVIEW);

  return (
    <HomeDashboard
      persona={isSuper ? 'super-admin' : 'admin'}
      showReviewKpis={canReview || isSuper}
      showSlaKpis={canReview || isSuper}
    />
  );
};

export default Home;
